import { memo } from 'react'

const NumberEditor = ({ onSubmit, placeholder = 'ใส่จำนวน' } : {
  onSubmit: (num: number) => void, placeholder?: string }) => {
  return <input className='px-3' type="number" inputMode="numeric"
    placeholder={placeholder} autoFocus={true} enterKeyHint='done'
    onBlur={(e) => {
      e.preventDefault()
      onSubmit(Number(e.currentTarget.value))
    }}
    onKeyDown={(e) => {
      if (e.code === 'Enter') {
        e.preventDefault()
        onSubmit(Number(e.currentTarget.value))
      }
    }}
  />
}

export default memo(NumberEditor)
